export default [
  {
    id: 'c1e76fe1-a26d-4a29-91c6-dc902fec77e5',
    path: 'data-collection-manage',
    name: 'data-collection-manage',
    meta: { title: '数据采集管理' },
    children: [
      {
        id: '4b752555-208b-4cbb-b028-45288470811c',
        path: 'tag',
        name: 'tag',
        component: () => {
          return import('../views/dataCollectionManage/tag')
        },
        meta: {
          title: '实体对象',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '浏览位号',
              access: true,
            },
          },
        },
      },
      {
        id: 'dc12039f-8616-4aba-b181-bf24b2010ecf',
        path: 'document',
        name: 'document',
        component: () => {
          return import('../views/dataCollectionManage/document')
        },
        meta: {
          title: '实体文档',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '浏览文档',
              access: true,
            },
            uploadFile: {
              id: 6,
              name: 'uploadFile',
              desc: '上传文件',
              access: true,
            },
            downloadFile: {
              id: 7,
              name: 'downloadFile',
              desc: '下载文件',
              access: true,
            },
          },
        },
      },
      {
        id: 'f076bd06-046d-4cc1-a2d1-a95a839eda02',
        path: 'relation',
        name: 'relation',
        component: () => {
          return import('../views/dataCollectionManage/relation')
        },
        meta: {
          title: '关联关系',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: '20e0934d-67ec-43d6-a5c0-acbbad802184',
        path: 'associated-objects',
        name: 'associated-objects',
        component: () => {
          return import('../views/dataCollectionManage/associatedObjects')
        },
        meta: {
          title: '关联对象',
          keepAlive: false,
          operations: {
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '解除关联',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: 'a9e7714b-a59d-4363-b3bf-faa88f1fb785',
        path: 'collection-manage',
        name: 'collection-manage',
        component: () => {
          return import('../views/dataCollectionManage/collectionManage')
        },
        meta: { title: 'ETL工具' },
      },
      {
        id: 'b0f2f4d5-6ff5-4f6c-b421-fef4a373dfbf',
        path: 'data-source',
        name: 'data-source',
        component: () => {
          return import('../views/dataCollectionManage/dataSource')
        },
        meta: { title: '数据源管理' },
      },
      {
        id: 'f74fec88-cac8-47e1-97f1-8f45446da595',
        path: 'reconciliation-list',
        name: 'reconciliation-list',
        component: () => {
          return import('../views/dataCollectionManage/reconciliationList')
        },
        meta: {
          title: '采集对账',
          keepAlive: false,
        },
      },
      {
        id: '53835d8b-5eaf-4b4a-b386-3c193630f1a1',
        path: 'tag-object-browse',
        name: 'tag-object-browse',
        component(resolve) {
          require(['../views/assetsBrowse/tagObjectBrowse'], resolve)
        },
        meta: {
          title: '位号浏览',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-collection-manage/tag',
        },
      },
      {
        id: '27adaef6-7478-43c5-b377-05f3c153c2b4',
        path: 'doc-view',
        name: 'doc-view',
        component(resolve) {
          require(['../views/docView/index'], resolve)
        },
        meta: {
          title: '文档浏览',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-collection-manage/document',
        },
      },
      {
        id: '6abd6302-d2a2-4b73-a4e5-07a01a1a56d6',
        path: 'object-collection-config',
        name: 'object-collection-config',
        component: () => {
          return import('../views/dataCollectionManage/objectCollectionConfig')
        },
        meta: {
          title: '实体对象采集配置',
          keepAlive: false,
        },
      },
      {
        id: 'e0f270d0-41e8-43a6-972d-951ece477c14',
        path: 'monitor',
        name: 'monitor',
        component: () => {
          return import('../views/dataCollectionManage/monitor')
        },
        meta: {
          title: '数据采集监控',
          keepAlive: false,
        },
      },
    ],
  },
]
